import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const sectionClass = 'mb-12';
  const headingClass =
    'text-xl font-bold text-white mb-4';
  const subHeadingClass =
    'text-base font-semibold mb-2';
  const paraClass =
    'text-gray-400 text-sm leading-relaxed mb-3';
  const listClass =
    'list-disc list-inside text-gray-400 text-sm leading-relaxed space-y-1 mb-3 pl-2';

  return (
    <div
      className="min-h-screen bg-black text-white"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      {/* Top Bar */}
      <div
        className="w-full py-4 border-b"
        style={{ borderColor: 'rgba(212,175,55,0.2)', background: '#0a0a0a' }}
      >
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            <span className="tracking-widest uppercase text-xs">Torna al Sito</span>
          </Link>
          <span
            className="text-xs tracking-widest uppercase"
            style={{ color: '#D4AF37', fontWeight: 500 }}
          >
            Filmodeling
          </span>
        </div>
      </div>

      {/* Hero */}
      <div
        className="py-20 text-center border-b relative overflow-hidden"
        style={{ borderColor: 'rgba(212,175,55,0.1)', background: 'linear-gradient(180deg, #0a0a0a 0%, #0f0d08 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 100%, rgba(212,175,55,0.07) 0%, transparent 70%)' }} />
        <span
          className="inline-block border border-yellow-600/60 text-yellow-500 text-xs tracking-widest uppercase px-5 py-2 rounded-full mb-6"
        >
          Documento Legale
        </span>
        <h1
          className="text-4xl md:text-6xl font-bold text-white mb-4"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Privacy &amp;{' '}
          <span style={{ color: '#D4AF37' }}>Cookie Policy</span>
        </h1>
        <p className="text-gray-500 text-sm mt-4">
          Ultimo aggiornamento: 20 Marzo 2026
        </p>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-20">

        {/* Intro */}
        <div className={sectionClass}>
          <p className={paraClass}>
            La presente informativa descrive le modalità di raccolta, utilizzo, conservazione e protezione
            dei dati personali degli utenti che visitano il sito web di <strong className="text-white">Filmodeling</strong> (
            <em>Via Raffaele Viviani 7, Pozzuoli</em>) e che compilano il modulo di iscrizione al Casting Open Day.
          </p>
          <p className={paraClass}>
            Il trattamento dei dati avviene nel rispetto del <strong className="text-white">Regolamento (UE) 2016/679 (GDPR)</strong>,
            del D.Lgs. 196/2003 (Codice Privacy) e delle relative modifiche apportate dal D.Lgs. 101/2018.
          </p>
        </div>

        {/* Divider */}
        <div className="h-px w-full mb-12" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.3), transparent)' }} />

        {/* 1. Titolare */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            1. Titolare del Trattamento
          </h2>
          <p className={paraClass}>
            <strong className="text-white">Filmodeling</strong><br />
            Sede: Via Raffaele Viviani 7, 80078 Pozzuoli (NA)<br />
            Email: <a href="mailto:info@filmodeling.it" className="underline hover:text-yellow-500 transition-colors">info@filmodeling.it</a>
          </p>
        </div>

        {/* 2. Dati raccolti */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            2. Dati Personali Raccolti
          </h2>
          <p className={paraClass}>
            Attraverso il modulo di iscrizione al Casting Open Day raccogliamo i seguenti dati:
          </p>
          <ul className={listClass}>
            <li>Nome e cognome</li>
            <li>Indirizzo email</li>
            <li>Numero di telefono / WhatsApp</li>
            <li>Età</li>
            <li>Settore di interesse (Moda/Modelling, Cinema/Recitazione, Entrambi)</li>
            <li>Messaggio libero facoltativo</li>
          </ul>
          <p className={paraClass}>
            Tramite la navigazione del sito possono essere raccolti automaticamente dati tecnici come
            indirizzo IP, tipo di browser, sistema operativo e pagine visitate (vedi sezione Cookie).
          </p>
        </div>

        {/* 3. Finalità */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            3. Finalità e Base Giuridica del Trattamento
          </h2>
          <div className="space-y-6">
            <div>
              <p className={`${subHeadingClass} text-white`}>a) Gestione delle iscrizioni all'Open Day</p>
              <p className={paraClass}>
                I dati forniti tramite il modulo di contatto vengono trattati per gestire la tua candidatura,
                contatiarti per la conferma del posto e organizzare l'evento.
                Base giuridica: <strong className="text-white">consenso dell'interessato</strong> (art. 6, par. 1, lett. a GDPR).
              </p>
            </div>
            <div>
              <p className={`${subHeadingClass} text-white`}>b) Comunicazioni informative e promozionali</p>
              <p className={paraClass}>
                Previo tuo consenso esplicito, potremmo inviarti informazioni sui nostri corsi, eventi futuri e
                attività di Filmodeling. Puoi revocare il consenso in qualsiasi momento.
                Base giuridica: <strong className="text-white">consenso</strong> (art. 6, par. 1, lett. a GDPR).
              </p>
            </div>
            <div>
              <p className={`${subHeadingClass} text-white`}>c) Obblighi di legge</p>
              <p className={paraClass}>
                In caso di richiesta da parte di autorità competenti, potremmo essere tenuti a fornire i tuoi dati.
                Base giuridica: <strong className="text-white">obbligo legale</strong> (art. 6, par. 1, lett. c GDPR).
              </p>
            </div>
          </div>
        </div>

        {/* 4. Conservazione */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            4. Periodo di Conservazione
          </h2>
          <p className={paraClass}>
            I dati raccolti tramite il modulo di iscrizione sono conservati per il tempo strettamente necessario
            alla gestione dell'evento e, salvo tuo consenso per comunicazioni future, vengono eliminati entro
            <strong className="text-white"> 12 mesi</strong> dalla data dell'Open Day.
          </p>
          <p className={paraClass}>
            I dati di navigazione raccolti automaticamente vengono conservati per un periodo non superiore a
            <strong className="text-white"> 12 mesi</strong>, salvo diversa necessità prevista dalla legge.
          </p>
        </div>

        {/* 5. Terze parti */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            5. Comunicazione a Terze Parti
          </h2>
          <p className={paraClass}>
            I tuoi dati personali <strong className="text-white">non vengono venduti né ceduti a terzi</strong> per finalità commerciali.
            Potrebbero essere condivisi solo con soggetti strettamente necessari per l'erogazione del servizio, quali:
          </p>
          <ul className={listClass}>
            <li>Fornitori di servizi tecnici (es. piattaforma di raccolta moduli) operanti come Responsabili del Trattamento ai sensi dell'art. 28 GDPR</li>
            <li>Autorità pubbliche in caso di obbligo di legge</li>
          </ul>
          <p className={paraClass}>
            Tutti i fornitori sono contrattualmente vincolati alla riservatezza e al rispetto del GDPR.
          </p>
        </div>

        {/* 6. Diritti */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            6. I Tuoi Diritti (GDPR)
          </h2>
          <p className={paraClass}>
            Ai sensi degli articoli 15–22 del GDPR, hai il diritto di:
          </p>
          <ul className={listClass}>
            <li><strong className="text-white">Accesso</strong> — ottenere conferma che i tuoi dati siano trattati e riceverne una copia</li>
            <li><strong className="text-white">Rettifica</strong> — richiedere la correzione di dati inesatti</li>
            <li><strong className="text-white">Cancellazione</strong> ("diritto all'oblio") — richiedere l'eliminazione dei tuoi dati</li>
            <li><strong className="text-white">Limitazione</strong> — richiedere la sospensione del trattamento in determinati casi</li>
            <li><strong className="text-white">Portabilità</strong> — ricevere i tuoi dati in formato strutturato</li>
            <li><strong className="text-white">Opposizione</strong> — opporti al trattamento per finalità di marketing diretto</li>
            <li><strong className="text-white">Revoca del consenso</strong> — in qualsiasi momento, senza pregiudizio per la liceità del trattamento precedente</li>
          </ul>
          <p className={paraClass}>
            Per esercitare i tuoi diritti, scrivi a:{' '}
            <a href="mailto:info@filmodeling.it" className="underline hover:text-yellow-500 transition-colors">info@filmodeling.it</a>
          </p>
          <p className={paraClass}>
            Hai inoltre il diritto di proporre reclamo al{' '}
            <a
              href="https://www.garanteprivacy.it"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="underline hover:text-yellow-500 transition-colors"
            >
              Garante per la Protezione dei Dati Personali
            </a>{' '}
            (www.garanteprivacy.it).
          </p>
        </div>

        {/* Divider */}
        <div className="h-px w-full mb-12" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.3), transparent)' }} />

        {/* Cookie Policy */}
        <div className={sectionClass}>
          <h2
            className="text-3xl font-bold text-white mb-8"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Cookie Policy
          </h2>

          <div className="mb-8">
            <h3
              className={headingClass}
              style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
            >
              7. Cosa sono i Cookie
            </h3>
            <p className={paraClass}>
              I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo quando li visiti.
              Vengono utilizzati per far funzionare il sito correttamente, migliorare l'esperienza utente e,
              in alcuni casi, raccogliere informazioni statistiche o di marketing.
            </p>
          </div>

          <div className="mb-8">
            <h3
              className={headingClass}
              style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
            >
              8. Tipologie di Cookie Utilizzati
            </h3>

            {[
              {
                name: 'Cookie Tecnici (Necessari)',
                badge: 'Sempre attivi',
                badgeColor: '#2a7a2a',
                desc: 'Indispensabili per il corretto funzionamento del sito. Non richiedono consenso. Comprendono cookie di sessione, gestione della navigazione e preferenze di base. Non raccolgono informazioni personali identificabili.',
              },
              {
                name: 'Cookie Analitici',
                badge: 'Previo consenso',
                badgeColor: '#7a5c00',
                desc: 'Utilizzati per raccogliere statistiche anonime sul comportamento degli utenti (es. Google Analytics con IP anonimizzato). Ci aiutano a capire come viene usato il sito per migliorarlo. I dati sono aggregati e non identificano individualmente gli utenti.',
              },
              {
                name: 'Cookie di Profilazione / Marketing',
                badge: 'Previo consenso',
                badgeColor: '#7a5c00',
                desc: 'Possono essere utilizzati per mostrare contenuti pubblicitari rilevanti su altri siti (es. Facebook Pixel, Google Ads). Vengono attivati solo se fornisci il tuo esplicito consenso.',
              },
            ].map((c) => (
              <div
                key={c.name}
                className="mb-5 rounded-xl border p-6"
                style={{ borderColor: 'rgba(212,175,55,0.15)', background: '#0d0d0d' }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <span
                    className="font-semibold text-white text-sm"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {c.name}
                  </span>
                  <span
                    className="text-xs px-3 py-1 rounded-full"
                    style={{ background: c.badgeColor, color: '#fff', fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {c.badge}
                  </span>
                </div>
                <p className={`${paraClass} mb-0`}>{c.desc}</p>
              </div>
            ))}
          </div>

          <div className="mb-8">
            <h3
              className={headingClass}
              style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
            >
              9. Come Gestire i Cookie
            </h3>
            <p className={paraClass}>
              Puoi gestire, disabilitare o eliminare i cookie in qualsiasi momento tramite le impostazioni del tuo browser:
            </p>
            <ul className={listClass}>
              <li>
                <strong className="text-white">Chrome:</strong>{' '}
                Impostazioni &gt; Privacy e sicurezza &gt; Cookie e altri dati dei siti
              </li>
              <li>
                <strong className="text-white">Firefox:</strong>{' '}
                Opzioni &gt; Privacy e sicurezza &gt; Cookie e dati dei siti web
              </li>
              <li>
                <strong className="text-white">Safari:</strong>{' '}
                Preferenze &gt; Privacy &gt; Gestisci dati dei siti web
              </li>
              <li>
                <strong className="text-white">Edge:</strong>{' '}
                Impostazioni &gt; Cookie e autorizzazioni per i siti
              </li>
            </ul>
            <p className={paraClass}>
              Tieni presente che disabilitare alcuni cookie potrebbe influire sul corretto funzionamento del sito.
            </p>
          </div>

          <div className="mb-8">
            <h3
              className={headingClass}
              style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
            >
              10. Cookie di Terze Parti
            </h3>
            <p className={paraClass}>
              Il sito può includere contenuti o strumenti di terze parti (es. video YouTube, widget social, Google Fonts)
              che potrebbero impostare i propri cookie. Queste terze parti sono soggette alle rispettive privacy policy.
              Filmodeling non è responsabile dei cookie di terze parti.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full mb-12" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.3), transparent)' }} />

        {/* Modifiche */}
        <div className={sectionClass}>
          <h2
            className={headingClass}
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            11. Modifiche alla Presente Informativa
          </h2>
          <p className={paraClass}>
            Filmodeling si riserva il diritto di aggiornare la presente informativa in qualsiasi momento,
            in particolare a seguito di modifiche normative o tecnologiche. La data dell'ultimo aggiornamento
            è indicata in cima alla pagina. Ti invitiamo a consultarla periodicamente.
          </p>
        </div>

        {/* Contatti */}
        <div
          className="rounded-2xl border p-8 text-center"
          style={{
            borderColor: '#D4AF37',
            background: 'linear-gradient(135deg, #0d0d0d 0%, #1a1200 50%, #0d0d0d 100%)',
            boxShadow: '0 0 40px rgba(212,175,55,0.08)',
          }}
        >
          <h3
            className="text-2xl font-bold text-white mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Hai domande?{' '}
            <span style={{ color: '#D4AF37' }}>Scrivici</span>
          </h3>
          <p className={`${paraClass} mb-5`}>
            Per qualsiasi richiesta relativa al trattamento dei tuoi dati personali contattaci a:
          </p>
          <a
            href="mailto:info@filmodeling.it"
            className="inline-block px-8 py-3 rounded-md font-bold tracking-widest uppercase text-sm transition-all duration-300 cursor-pointer hover:scale-105 whitespace-nowrap"
            style={{
              background: 'linear-gradient(90deg, #b8860b, #D4AF37, #f0d060, #D4AF37, #b8860b)',
              color: '#000',
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            info@filmodeling.it
          </a>
        </div>

        {/* Back */}
        <div className="mt-14 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-500 hover:text-yellow-500 transition-colors text-sm cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-arrow-left-line" />
            <span className="tracking-widest uppercase text-xs">Torna alla Home</span>
          </Link>
        </div>
      </div>

      {/* Mini Footer */}
      <div
        className="border-t py-6 text-center"
        style={{ borderColor: 'rgba(212,175,55,0.15)', background: '#0a0a0a' }}
      >
        <p
          className="text-gray-600 text-xs"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          © 2026 Filmodeling · Via Raffaele Viviani 7, Pozzuoli · Privacy &amp; Cookie Policy
        </p>
      </div>
    </div>
  );
}
